import React, { useMemo } from 'react';
import { useLocale } from '@/shared/hooks/use-locale';
import { isSamePath } from '@/shared/hooks/use-open-popup-from-get-params';
import { tp } from '@/shared/lib/typograf';
import Button from '../../shared/Button';
import Link from '../../shared/Link';

export interface ServicesContentHeaderProps {
    title: string;
    description: string;
    link: {
        name: string;
        href: string;
    } | null;
}

type Props = React.HTMLAttributes<HTMLElement> & {
    servicesContentHeader: ServicesContentHeaderProps;
};

export default function ServicesContentHeader({ servicesContentHeader }: Props) {
    const locale = useLocale();
    const tpTitle = useMemo(() => tp(servicesContentHeader.title || '', locale), [servicesContentHeader.title, locale]);
    const tpContent = useMemo(
        () => tp(servicesContentHeader.description || '', locale),
        [servicesContentHeader.description, locale],
    );

    return (
        <div className="wrapper">
            <div className="services-title-block__header">
                <div className="services-title__header h3">{tpTitle}</div>
                {(servicesContentHeader.description || servicesContentHeader.link?.href) && (
                    <div className="services-description-block__header">
                        {servicesContentHeader.description && (
                            <div className="services-description__header text-s">{tpContent}</div>
                        )}
                        {servicesContentHeader.link && servicesContentHeader.link.href && (
                            <Button
                                tag={Link}
                                href={servicesContentHeader.link.href}
                                target={isSamePath(servicesContentHeader.link.href) ? undefined : '_blank'}
                                rel={isSamePath(servicesContentHeader.link.href) ? undefined : 'noreferrer nofollow'}
                                className="services-header-btn"
                                variant="outline-dark"
                            >
                                {servicesContentHeader.link.name ?? 'Подать заявку'}
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
